import type { GetQuestionGroupByIdQuery } from '@exam-management/graphql';

export type ItemSet = GetQuestionGroupByIdQuery['qctGetQuestionGroupById'];

export enum PublishValidationErrorCode {
  EMPTY = 'EMPTY',
  MALFORMED = 'MALFORMED',
  NOT_ENOUGH_QUESTIONS = 'NOT_ENOUGH_QUESTIONS',
}

export interface PublishValidationError {
  code: PublishValidationErrorCode;
  field: string;
  value?: string;
}
